var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2a6 6 0 110 12A6 6 0 018 2zm0 8a.75.75 0 100 1.5.75.75 0 000-1.5zm0-5.5a.5.5 0 00-.492.41L7.5 5v3.5l.008.09a.5.5 0 00.984 0L8.5 8.5V5l-.008-.09A.5.5 0 008 4.5z",
    fill: "#BC221C"
  })));
}
export default SvgErrorCircleFilled;